import { render, staticRenderFns } from "./ConnectUs.vue?vue&type=template&id=6035c602"
var script = {}
import style0 from "./ConnectUs.vue?vue&type=style&index=0&id=6035c602&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports